import React, { useCallback } from "react"
import { Search, CloseLarge } from "@/skylticons"

interface SearchBoxProps {
  placeholder?: string
  search: string
  setSearchQuery: (e: string) => void
  handleSearch: () => void
  handleKeyUp: (e: React.KeyboardEvent) => void
}

const SearchBox: React.FC<SearchBoxProps> = ({ placeholder, search, setSearchQuery, handleKeyUp, handleSearch }) => {
  const changeValue = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setSearchQuery(e.target.value)
    },
    [setSearchQuery]
  )

  const clear = useCallback(() => {
    setSearchQuery("")
  }, [setSearchQuery])

  return (
    <div className="flex justify-between rounded border-1 border-white-20 bg-white-5 focus-within:border-primary focus-within:outline focus-within:outline-2 focus-within:outline-aqua-200 hover:border-ink-50 hover:focus-within:border-primary">
      <input
        placeholder={placeholder}
        onChange={changeValue}
        className="search-box w-full border-none bg-white-5 px-4 py-3 focus:outline-none"
        value={search}
        onKeyUp={handleKeyUp}
      />
      <span className="flex items-center">
        {search.length > 0 && (
          <span className="m-auto cursor-pointer px-3" onClick={clear}>
            <CloseLarge width={24} height={24} />
          </span>
        )}
        <span className="m-auto h-6 border-l-1 border-white-20"></span>
        <span className="m-auto cursor-pointer px-3" onClick={handleSearch}>
          <Search width={24} height={24} />
        </span>
      </span>
    </div>
  )
}

export default SearchBox
